import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import FomBillEditor from "./FomBillEditor";
import PrivacyPolicy from "./PrivacyPolicy";
import SalesPortal from "./sales/SalesPortal";
import PublicProposalPage from "./sales/public/PublicProposalPage";
import CustomerReviewPage from "./sales/public/CustomerReviewPage";
import StudioApp from "./studio/StudioApp";
import { installToastTouchFix } from "./components/toastTouchFix";

installToastTouchFix();

const isFomRoute = window.location.pathname.startsWith("/fom/");
if (window.location.pathname === "/vendas" || window.location.pathname.startsWith("/vendas/")) {
  window.location.replace(window.location.pathname.replace(/^\/vendas/, "/sales") + window.location.search + window.location.hash);
}
const isSalesRoute = window.location.pathname === "/sales" || window.location.pathname.startsWith("/sales/");
const isStudioRoute = window.location.pathname === "/studio" || window.location.pathname.startsWith("/studio/");
const publicToken = (window.location.pathname.match(/^\/p\/([A-Za-z0-9_-]+)\/?$/) || [])[1];
const reviewToken = (window.location.pathname.match(/^\/review\/([A-Za-z0-9_-]+)\/?$/) || [])[1];
const isPrivacyRoute = window.location.pathname === "/privacy" || window.location.pathname === "/privacy/";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    {isPrivacyRoute ? <PrivacyPolicy /> : isFomRoute ? <FomBillEditor /> : publicToken ? <PublicProposalPage token={publicToken} /> : reviewToken ? <CustomerReviewPage token={reviewToken} /> : isStudioRoute ? <StudioApp /> : isSalesRoute ? <SalesPortal /> : <App />}
  </React.StrictMode>,
);
